import { api } from '@/core/api/client'
import type { Payment, PaymentStatus } from '@/features/classes/stores/types'

const paymentsCollection = api.collection<Payment>('payments')

export async function fetchPayments(): Promise<Payment[]> {
  return paymentsCollection.getFullList({ sort: '-created_at' })
}

export async function fetchPaymentById(id: string): Promise<Payment | null> {
  try {
    return await paymentsCollection.getOne(id)
  } catch {
    return null
  }
}

export async function fetchPaymentsByStatus(status: PaymentStatus): Promise<Payment[]> {
  const all = await paymentsCollection.getFullList()
  return all.filter((p) => p.status === status)
}

export async function fetchOrderPayments(orderId: string): Promise<Payment[]> {
  const all = await paymentsCollection.getFullList()
  return all.filter((p) => p.orderId === orderId)
}

export async function createPayment(data: {
  orderId?: string
  stripePaymentId: string
  stripePaymentIntentId?: string
  amount: number
  currency: string
  status: PaymentStatus
  customerEmail?: string
  customerName?: string
  stripeCustomerId?: string
}): Promise<Payment> {
  return paymentsCollection.create(data)
}

export async function updatePayment(
  id: string,
  data: Partial<{
    status: PaymentStatus
    stripePaymentIntentId: string
  }>
): Promise<Payment> {
  return paymentsCollection.update(id, data)
}

export async function deletePayment(id: string): Promise<void> {
  await paymentsCollection.delete(id)
}

export async function getTotalRevenue(): Promise<number> {
  const payments = await paymentsCollection.getFullList()
  return payments.filter((p) => p.status === 'succeeded').reduce((sum, p) => sum + p.amount, 0) / 100
}

export async function getTotalRevenueCents(): Promise<number> {
  return getTotalRevenue()
}
